import Swal from "sweetalert2";
import { domain } from "../../../Urls/Services/Api_urls";
import { trackPlanesClick, trackFormSubmit } from "../../../../utils/gtm";

export const calling = (props) => {
    trackPlanesClick(props);
    Swal.fire({
      title: `${props}`,
      html: ` 
              
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Nombre *</label>
                      <input id="nombre" class="swal2-input" placeholder="Nombre *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Apellido *</label>
                      <input id="apellido" class="swal2-input" placeholder="Apellido *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Telefono *</label>
                      <input id="telefono" class="swal2-input" placeholder="Telefono *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Correo electronico *</label>
                      <input id="mail" class="swal2-input" placeholder="Correo electronico *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Dirección *</label>
                      <input id="direccion" class="swal2-input" placeholder="Dirección *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Barrio *</label>
                      <input id="neighborhood" class="swal2-input" placeholder="Barrio" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Ciudad *</label>
                      <select class="select swal2-input" id="mySelectElement" style="width: 70%; height: 3.4rem; margin: 0.3rem auto 1rem; border: 1px solid;">
                        <option value="Cali">Cali</option>
                        <option value="Jamundi">Jamundi</option>
                        <option value="Yumbo">Yumbo</option>
                        <option value="Candelaria">Candelaria</option>
                        <option value="Puerto tejaada">Puerto tejaada</option>
                        <option value="Palmira">Palmira</option>
                     </select>
                      `,

      confirmButtonColor: "#4a1272",
      confirmButtonText: "Enviar",
      showCloseButton: true,
      focusConfirm: false,
      preConfirm: () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          name: document.getElementById("nombre").value,
          last_name: document.getElementById("apellido").value,
          phone: document.getElementById("telefono").value,
          address: document.getElementById("direccion").value,
          mail: document.getElementById("mail").value,
          neighborhood: document.getElementById("neighborhood").value,
          city: document.getElementById("mySelectElement").value,
          service: props,
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        return fetch(domain + "/portal/out/", requestOptions)
        .then((response) => {
          // Intenta convertir la respuesta en JSON
          return response.json().then((data) => {
            if (!response.ok) {
              // Si la respuesta no es OK, lanza un error con el mensaje devuelto
              const errorMsg = data.msg || response.statusText;
              throw new Error(errorMsg);
            }
            // Si todo va bien, muestra el mensaje de éxito
            trackFormSubmit("asesoramos_planes", props);
            Swal.fire({
              icon: "success",
              title: "Perfecto!",
              text: "Nos contactaremos contigo muy pronto!",
            });
          });
        })
        .catch((error) => {
          // Imprime el mensaje de error en la consola
          console.error(error.message);
          // Muestra el mensaje de error en la validación de Swal
          Swal.showValidationMessage(`Hay errores en el formulario, ${error.message}`);
        });
      },
    });
  };